import { useContext } from 'react';
import { OpenXAgentContext } from './OpenXAgentContext';

export const useOpenXAgentContext = () => {
  const context = useContext(OpenXAgentContext);

  if (!context) {
    throw new Error('useOpenXAgentContext must be used within a OpenXAgentProvider');
  }

  return context;
};
